import type { IConsentGroup } from '../types/IConsentConfig';

export const formularConsentGroup: IConsentGroup = {
  key: 'formulars',
  title: 'Formulare',
  items: [
    {
      title: 'Betterplace',
      description: 'Einbettung eines Spendenformulars',
      key: 'allowBetterPlace',
    },
    {
      title: 'Zoho Bookings',
      description: 'Tool zur Online-Terminvereinbarung',
      key: 'allowZohoBookings',
    },
  ],
};
